import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {YoutubeSubscribeTriggerStruct} from '@cohort/shared/apps/youtube/triggers/subscribe';
import {useTranslation} from 'react-i18next';

const YoutubeSubscribeTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<YoutubeSubscribeTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-youtube', {
    keyPrefix: 'triggerIntegrations.subscribe',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} withRefresh />;
};

export default YoutubeSubscribeTriggerActionCtaComponentPreview;
